export const channelIdList = [29, 17, 18, 19, 12, 9] // 生产环境需要自动收集表单页面channelId集合
// export const channelIdList = [54, 44, 40, 39] // 测试环境需要自动收集表单页面channelId集合  摄影：54,44,   月子中心：40，产康：39

export const level4CategoryIdList = ['10121110', '10121111', '10121112', '10121115', '10111018', '10112110', '10112111', '10112112', '10112113', '10112114', '10112115', '10112116'] // 需要自动收集表单页面level4CategoryId集合

enum CATEGORY_ID {
  PHOTO = 29, // 摄影
  MOTHERPHOTO = 17, // 孕妈摄影
  KIDPHOTO = 18, // 婴童摄影
  CHILDPHOTO = 19, // 儿童摄影
  YUEZICENTER = 12, // 月子中心
  RECOVERY = 9 // 产后恢复
}

export const CATEGORY_ID_MAP = {
  [CATEGORY_ID.PHOTO]: '10121115',
  [CATEGORY_ID.MOTHERPHOTO]: '10121115',
  [CATEGORY_ID.KIDPHOTO]: '10121115',
  [CATEGORY_ID.CHILDPHOTO]: '10121115',
  [CATEGORY_ID.YUEZICENTER]: '10111018',
  [CATEGORY_ID.RECOVERY]: '10112110'
}

// enum CATEGORY_ID {
//   PHOTO = 54, // 摄影
//   MOTHERPHOTO = 44, // 孕妈摄影
//   YUEZICENTER = 40, // 月子中心
//   RECOVERY = 39 // 产后恢复
// }

// export const CATEGORY_ID_MAP = {
//   [CATEGORY_ID.PHOTO]: '10121115',
//   [CATEGORY_ID.MOTHERPHOTO]: '10121115',
//   [CATEGORY_ID.YUEZICENTER]: '10111018',
//   [CATEGORY_ID.RECOVERY]: '10112110'
// }
